// extracted by mini-css-extract-plugin
export default {"bubble":"TodosProgressionBadge_bubble__LptWZ","arrow":"TodosProgressionBadge_arrow__raFWM","title":"TodosProgressionBadge_title__Gieka","list":"TodosProgressionBadge_list__sc5iO"};